import DevicesColumn from './DevicesColumn';

export default DevicesColumn;
